'use client';

import dynamic from 'next/dynamic';
import { FC, useState } from 'react';
import useDeferUntilIdle from '@/hooks/use-defer-until-idle';
import { useTranslation } from '@/providers/app-provider/app-provider';

const GlobalSearchAutocomplete = dynamic(() => import('./global-search-autocomplete'), {
  ssr: false,
});

type DeferredDesktopGlobalSearchProps = {
  className?: string;
};

const DeferredDesktopGlobalSearch: FC<DeferredDesktopGlobalSearchProps> = ({ className }) => {
  const { t } = useTranslation();
  const isIdleReady = useDeferUntilIdle({ timeout: 3000 });
  const [isActivated, setIsActivated] = useState(false);

  if (isActivated || isIdleReady) {
    return (
      <GlobalSearchAutocomplete className={className} onCloseExtra={() => setIsActivated(false)} />
    );
  }

  return (
    <input
      type="search"
      aria-label={t?.common.layout.search ?? 'Search'}
      placeholder={t?.common.layout.search}
      className={className}
      onFocus={() => setIsActivated(true)}
      readOnly
    />
  );
};

export default DeferredDesktopGlobalSearch;
